import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import PhoneNumber from "@/model/interface/PhoneNumber";
import { AssignCallFlowDialog } from "./AssignCallFlowDialog";

interface PhoneNumberCallFlowCellProps {
  phoneNumber: PhoneNumber;
}

export function PhoneNumberCallFlowCell({ phoneNumber }: PhoneNumberCallFlowCellProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const assignedFlow = phoneNumber.callFlow;

  return (
    <>
      {assignedFlow ? (
        <div className="flex items-center gap-2">
          <span className="text-sm">{assignedFlow.name}</span>
          <Button variant="outline" size="sm" onClick={() => setDialogOpen(true)}>
            Change Flow
          </Button>
        </div>
      ) : (
        <Button variant="outline" size="sm" onClick={() => setDialogOpen(true)}>
          Assign Flow
        </Button>
      )}

      <AssignCallFlowDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        phoneNumber={phoneNumber}
        assignedFlow={assignedFlow}
      />
    </>
  );
}
